<template>
    <div>

    <hb-form label="Pin Length">
      {{connection.Credentials.pin_format}}
    </hb-form>

    <!-- <hb-bottom-action-bar
      :cancel-off="connection.Credentials.connected"
      @close="$emit('cancel')"
      :top-border="false"
      v-resize="setAuditCollapse"
      ref="bottomRemoveBar"
      >
      <template v-slot:left-actions v-if="connection.Credentials.connected && connection.modified_at && connection.modified_by_fullname">
        <hb-tooltip v-if="collapseAudit">
          <template v-slot:item>
            <v-row no-gutters align="center">
              <hb-icon 
                mdi-code="mdi-account-clock-outline"
                small
                color="#101318"  
                class="mr-2 ml-4 mt-0 mb-1"
              >
              </hb-icon>
            </v-row>
          </template>
          <template v-slot:body>
            {{connection.modified_by_fullname}}<br>{{editTime}}
          </template>
        </hb-tooltip>
        <v-row no-gutters align="center" v-else>
          <hb-icon 
            mdi-code="mdi-account-clock-outline"
            small
            color="#101318" 
            class="mr-2 ml-4 mt-0 mb-1"
          >
          </hb-icon>
          <v-col class="py-0 my-0 hb-font-caption">
            {{connection.modified_by_fullname + " (" + editTime + ")"}}
          </v-col>
        </v-row>
      </template>
      <template v-slot:right-actions>
        <hb-btn
          v-if="!connection.Credentials.connected"
          :disabled="!property_id || savingInProgress"
          :loading="savingInProgress"
          @click="save"
        >
          Connect to DMS
        </hb-btn>
        <hb-btn
          v-if="connection.Credentials.connected"
          color="secondary"
          :disabled="!connection.access_id || removeInProgress"
          :loading="removeInProgress"
          @click="$emit('confirmRemoveAccess')"
        >
          <span class="hb-text-error">Remove Integration</span>
        </hb-btn>
      </template>
    </hb-bottom-action-bar> -->
    </div>
  </template>
  <script type="text/babel">
  import api from "../../../assets/api.js";
  import { EventBus } from "../../../EventBus.js";
  import { notificationMixin } from  '../../../mixins/notificationMixin.js';
  export default {
    name: "DMS",
	mixins: [ notificationMixin ],
    data() {
      return {
        connection: {
          property_id: "",
          access_id: "",
          Credentials: {
            site_key: "",
            modified_by_fullname: "",
            modified_at: "",
            connected: false,
            pin_format: '8'
          }
        },
        savingInProgress: false,
        collapseAudit: false
      };
    },
    created() {
      this.$emit('connectButtonText', "Connect To DMS");
    },
    mounted() {

      if(this.$props.access.Credentials) {
        this.connection = this.$props.access;
      }
    },
    destroyed() {
      this.$validator.errors.clear();
    },
    computed: {
      editTime(){
          if(this.connection.modified_at) return this.$options.filters.formatDateTime(this.connection.modified_at);
          return '';
      }
    },
    methods: {
      async fetchData() {
        EventBus.$emit('fetchSettingsAccess');
      },
      async save() {
        let status = await this.$validator.validate();
        if (!status) {
          this.showMessageNotification({ type: 'error', description: 'There are errors in your form, correct them before continuing.', list: this.errors.items });
          return;
        } 
        
        this.savingInProgress = true;
  
        var data = {
          property_id: this.$props.property_id,
          access_id: this.$props.selectedGateAccessId,
          satellite_flag: this.connection.satellite_flag,
          Credentials:{
            pin_format: this.connection.Credentials.pin_format,
          }
        };
  
        try {
  
          let r = await api.post(this, api.ACCESS_CONTROL, data);
          this.fetchData();
          this.showMessageNotification({ type: 'success', description: 'You have successfully connected to the DMS access control integration.' });
        } catch( err ) {
          this.showMessageNotification({ description: 'Please verify your credentials and try again or contact Customer Success for assistance.' });
        }

  
        this.savingInProgress = false;
      },
      setAuditCollapse() {
        let bottomBar = this.$refs.bottomRemoveBar;
        if (bottomBar && bottomBar.$el.offsetWidth > 0 && bottomBar.$el.offsetWidth < 570) {
          this.collapseAudit = true
        } else {
          this.collapseAudit = false
        }
      }
    },
    watch: {
      access() {
        this.connection = this.access;
      },
      savingInProgress(value) {
        this.$emit('update:savingAccess', value);
      },
      async saveInVendor(value) {
        if (value === true) {
          await this.save();
          this.$emit('update:saveInVendor', false);
        }
      }
    },
    props: ["property_id", "access", "selectedGateAccessId", "removeInProgress", "showUpdateButton", "savingAccess", "saveInVendor", "updateInVendor", "testVendorConnection"]
  };
  </script>